<template>
  <div>
    <LiveDetail />
  </div>
</template>

<script>
import LoadingSkeleton from "@/components/generic/LoadingSkeleton";

const LiveDetail = () => ({
  component: import('@/components/center_widgets/LiveDetail'),
  loading: LoadingSkeleton,
  timeout: 200
})

export default {
  name: 'LiveDetailPrematchView',
  components: { LiveDetail },
}
</script>
